export const tokens = {
  darkCyan: 'hsl(185, 75%, 39%)',
  vDarkBlue: 'hsl(229, 23%, 23%)',
  darkGrayBlue: 'hsl(227, 10%, 46%)',
  darkGray: 'hsl(0, 0%, 59%)'
};
